/*
  SMA — Cart rewards free-gift automation.

  The progress bar itself is pure Liquid. This script only keeps free-gift
  lines in sync with the tiers the cart currently qualifies for:

  - tier reached, gift not in cart  -> add it (tagged _sma_gift = <tier>)
  - tier not reached, gift in cart  -> remove it

  It performs at most ONE change per render. The change re-renders the drawer,
  which runs this again, so multiple tiers settle over successive passes and a
  misconfiguration can never spin. Gift lines are excluded from the totals in
  Liquid, so a gift can never push the cart over the next tier.

  The gift being free is a Shopify discount concern — set up an automatic
  discount (or price the product at zero) in the admin.
*/
(function () {
  'use strict';

  var MAX_PASSES = 6;
  var passes = 0;
  var busy = false;
  // Tiers whose add/remove Shopify rejected. Skipped on later passes so one
  // bad tier can never block the others, or burn the whole pass budget.
  var failedTiers = {};

  function sectionsPayload() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.getSectionsToRender !== 'function') return null;
    return {
      sections: drawer.getSectionsToRender().map(function (section) {
        return section.id;
      }),
      sections_url: window.location.pathname,
    };
  }

  function rerender(parsed) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && parsed && parsed.sections) {
      drawer.renderContents(parsed);
    } else {
      window.location.reload();
      return;
    }
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sma-cart-rewards', cartData: parsed });
    }
  }

  function post(url, body) {
    var extra = sectionsPayload();
    if (extra) {
      body.sections = extra.sections;
      body.sections_url = extra.sections_url;
    }
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (response) {
      return response.json();
    });
  }

  function addGift(gift) {
    var url = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
    return post(url, {
      items: [
        {
          id: Number(gift.variantId),
          quantity: 1,
          properties: { _sma_gift: String(gift.tier) },
        },
      ],
    });
  }

  function removeGift(gift) {
    var url = (window.routes && window.routes.cart_change_url ? window.routes.cart_change_url : '/cart/change') + '.js';
    return post(url, { id: gift.lineKey, quantity: 0 });
  }

  function sync() {
    if (busy) return;

    var node = document.querySelector('[data-sma-rewards-gifts]');
    if (!node) {
      passes = 0;
      return;
    }

    var gifts;
    try {
      gifts = JSON.parse(node.textContent);
    } catch (error) {
      return;
    }
    if (!gifts || !gifts.length) {
      passes = 0;
      return;
    }

    var action = null;

    for (var i = 0; i < gifts.length; i++) {
      var gift = gifts[i];
      if (failedTiers[gift.tier]) continue;
      if (gift.reached && gift.available && !gift.inCart) {
        action = { type: 'add', gift: gift };
        break;
      }
      if (!gift.reached && gift.inCart) {
        action = { type: 'remove', gift: gift };
        break;
      }
    }

    if (!action) {
      passes = 0;
      return;
    }

    if (passes >= MAX_PASSES) return;
    passes++;
    busy = true;

    var request = action.type === 'add' ? addGift(action.gift) : removeGift(action.gift);

    request
      .then(function (parsed) {
        busy = false;
        if (parsed && parsed.status) {
          // Shopify rejected it (sold out, quantity rule). Park this tier and
          // refund the pass so other tiers still get their turn.
          failedTiers[action.gift.tier] = true;
          passes--;
          return;
        }
        rerender(parsed);
      })
      .catch(function () {
        busy = false;
        failedTiers[action.gift.tier] = true;
        passes--;
      });
  }

  // Run after every drawer render. The drawer replaces its own innerHTML, so
  // watching the subtree is the reliable trigger.
  function observe() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.smaRewardsBound === 'true') return;
    drawer.dataset.smaRewardsBound = 'true';

    new MutationObserver(function () {
      window.requestAnimationFrame(sync);
    }).observe(drawer, { childList: true, subtree: true });

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }

  // A wholesale cart-drawer section reload replaces the element and takes the
  // observer with it. observe() is self-guarding, so re-running is safe.
  document.addEventListener('shopify:section:load', observe);
})();